import { MenuLinkRegex } from "../constants/menu-link-regex";

export abstract class AccessControl {
  private static defaultMenuLinks = [
    MenuLinkRegex.Routes,
    MenuLinkRegex.Allocation,
    MenuLinkRegex.Customers,
    MenuLinkRegex.Invoices,
    // RouterPath.Drivers + '**',
    MenuLinkRegex.Vehicles,
    MenuLinkRegex.Products,
    MenuLinkRegex.Messages,
  ];
  static accessRight = {
    Basic: {
      view: '',
      create: '*',
      edit: '*',
      remove: '*',
    },
    // Driver: {
    //   view: AccessControl.defaultMenuLinks,
    //   create: '*',
    //   edit: '*',
    //   remove: '*',
    // },
    Admin: {
      view: AccessControl.defaultMenuLinks,
      create: '*',
      edit: '*',
      remove: '*',
    },
    SuperAdmin: {
      view: [
        ...AccessControl.defaultMenuLinks,
        MenuLinkRegex.Users,
      ],
      create: '*',
      edit: '*',
      remove: '*',
    },
    SystemOwner: {
      view: [
        ...AccessControl.defaultMenuLinks,
        MenuLinkRegex.Users,
        MenuLinkRegex.Tenants,
      ],
      create: '*',
      edit: '*',
      remove: '*',
    },
    Guest: {
      view: [],
    }
  }
}
